// extracted by mini-css-extract-plugin
export default {"shimmer":"AuthLayout_shimmer__nS3Ln","dark_shimmer":"AuthLayout_dark_shimmer__vCdoV","auth_layout":"AuthLayout_auth_layout__8TWNF","auth_content":"AuthLayout_auth_content__mtvFa"};